module.exports = __webpack_public_path__ + "static/pic06-0f4370db947f1ec66257baed575b293e.jpg";